export default __webpack_public_path__ + "static/media/knife-edge.3271fcf0.webp";